import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchInput from "../../../../common/InlineSearch";
import DataTable from "../../../../common/DataTableAddress";
import CustomPagination from "../../../../common/Pagination";
import TableRowsPerPage from "../../../../common/TableRowsPerPage";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import { Container } from "react-bootstrap";
import Stack from "react-bootstrap/Stack";
import { GetAddressList } from "../../../../services/StakeholderApi";
import Loader from "../../../../common/Loader";
import StackHolderAddress from "./StackHolderAddress";
import { useNavigate } from "react-router-dom";
import { STAKEHOLDERS_ADDRESS } from "../actions/Constant";
import { Form, Modal, Button, Offcanvas, Row, Col } from "react-bootstrap";
import AccordionComponent from "../../../../common/Accordion";
import { PARTIES_MASTER_ACTIONS } from "../../../../common/EventConstant";

const AddressGrid: React.FC<any> = ({ userData, onCancel }) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(15);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const [isAddingAddress, setIsAddingAddress] = useState<boolean>(false);
  const [editingAddress, setEditingAddress] = useState<any | null>(null);
  const searchInputRef = useRef<any>(null);
  const [selectedUserData, setSelectedUserData] = useState<any>(null);
  const navigate = useNavigate();

  const [addressListKey, setAddressListKey] = useState<string | null>("0");

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures
  );

  const editContact = allowedFeatures.has(PARTIES_MASTER_ACTIONS.CONTACT_EDIT);

  const fetchAddressData = async (isLoader?: boolean) => {
    if (isLoader) setLoading(true);
    try {
      const response = await GetAddressList(userData);
      setData(response);
      setFilteredData(response);
    } catch (error) {
      console.error("Error fetching address data:", error);
    } finally {
      isLoader && setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddressData(true);
  }, [itemsPerPage, currentPage]);

  const handleAddAddressClick = () => {
    setEditingAddress(null);
    setIsAddingAddress(true);
    setAddressListKey(null);
  };

  const handleRowAction = (row: any, action: string) => {
    setIsAddingAddress(true);
    setSelectedUserData(action);
    setAddressListKey(null);
  };

  const handleAddressSaved = () => {
    setIsAddingAddress(false);
    fetchAddressData(true);
    setAddressListKey("0");
  };

  const handlefetchAddressData = () => {
    fetchAddressData(false);
  };

  const handleBack = () => {
    onCancel();
  };

  const addressListAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addressListKey}
      onSelect={(key) => setAddressListKey(key as string)}
    />
  );

  return (
    <div className="pb-4">
      {/* Show Add/Edit Address Form */}

      {isAddingAddress && (
        <div className="add-address-form">
          <StackHolderAddress
            userData={userData}
            action={editingAddress ? "edit" : "add"}
            onAddressSaved={handleAddressSaved}
            handlefetchAddressData={handlefetchAddressData}
            SelectedUserData={selectedUserData}
            onFormCancel={() => {
              setIsAddingAddress(false);
              setSelectedUserData(null);
              setAddressListKey("0"); // Reset selected user data
            }}
          />
        </div>
      )}

      {/* Data Grid Section - Visible Only if showAddressList is TRUE */}

      {!isAddingAddress && (
        <>
          {addressListAccordion([
            {
              title: "Address List",
              content: (
                <>
                  <div className="container-fluid px-0">
                    <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3">
                      <h3 className="mr-2 me-auto">List</h3>
                      {!isAddingAddress && editContact && (
                        <div className="address_cta_pos_relative mt-1">
                          <Stack direction="horizontal" gap={2}>
                            <button
                              onClick={handleAddAddressClick}
                              className="btn btn-primary d-flex align-items-center"
                            >
                              <span className="material-icons me-2">add</span>
                              Add
                            </button>
                          </Stack>
                        </div>
                      )}
                    </div>
                    <DataTable
                      headers={STAKEHOLDERS_ADDRESS}
                      rows={filteredData}
                      onAction={handleRowAction}
                    />
                  </div>
                </>
              ),
            },
          ])}
        </>
      )}
      {!isAddingAddress && (
        <button
          type="button"
          className="btn d-flex align-items-center btn-text-border"
          onClick={handleBack}
        >
          <span className="material-icons mr-2">arrow_back</span>Back
        </button>
      )}
      {loading && <Loader isLoading={loading} />}
    </div>
  );
};

export default AddressGrid;
